<template>
  <el-form-item class="shoot-address-item" label="作品拍摄地：" label-width="140px" required>
    <el-select
      v-model="level1"
      class="shoot-address-select"
      popper-class="shoot-address-dropdown"
      filterable
      placeholder="请选择乡镇"
      @change="onLevel1Change"
    >
      <el-option
        v-for="item in options"
        :key="item.label"
        :label="item.label"
        :value="item.label"
      />
    </el-select>
    <el-select
      v-model="level2"
      class="shoot-address-select"
      popper-class="shoot-address-dropdown"
      filterable
      placeholder="请选择文物名称"
      :disabled="!level1"
      @change="emitValue"
    >
      <el-option
        v-for="name in level2Options"
        :key="name"
        :label="name"
        :value="name"
      />
    </el-select>
  </el-form-item>
</template>

<script>
import { formatShootAddress, parseShootAddress } from "@/utils/matchContributeConfig";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      level1: "",
      level2: "",
    };
  },
  computed: {
    level2Options() {
      const group = this.options.find((item) => item.label === this.level1);
      return group ? group.children : [];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.syncFromValue(val);
      },
    },
    options() {
      this.syncFromValue(this.value);
    },
  },
  methods: {
    syncFromValue(val) {
      const parsed = parseShootAddress(val, this.options);
      if (parsed.level1 && parsed.level2) {
        this.level1 = parsed.level1;
        this.level2 = parsed.level2;
      }
    },
    onLevel1Change() {
      if (this.level2Options.indexOf(this.level2) === -1) {
        this.level2 = "";
      }
      this.emitValue();
    },
    emitValue() {
      this.$emit("input", formatShootAddress(this.level1, this.level2));
    },
  },
};
</script>

<style>
.shoot-address-item .el-form-item__label {
  white-space: nowrap;
}
.shoot-address-select {
  display: block;
  width: 100%;
}
.shoot-address-select + .shoot-address-select {
  margin-top: 12px;
}
.shoot-address-dropdown {
  max-width: 640px;
}
.shoot-address-dropdown .el-select-dropdown__item {
  height: auto;
  line-height: 22px;
  white-space: normal;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
